// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const UserSearch = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.73 7.437a5.84 5.84 0 0 0 5.832 5.834 5.84 5.84 0 0 0 5.834-5.834 5.84 5.84 0 0 0-5.834-5.833A5.84 5.84 0 0 0 4.73 7.437Zm-.834 0A6.674 6.674 0 0 1 10.562.771a6.674 6.674 0 0 1 6.667 6.666 6.674 6.674 0 0 1-6.666 6.667 6.636 6.636 0 0 1-4.407-1.67l-4.674 4.673a.415.415 0 0 1-.59 0 .417.417 0 0 1 0-.59l4.674-4.673a6.637 6.637 0 0 1-1.67-4.407Zm6.25-3.333c0-.23.186-.417.416-.417a3.754 3.754 0 0 1 3.75 3.75.417.417 0 0 1-.833 0 2.92 2.92 0 0 0-2.916-2.916.417.417 0 0 1-.417-.417Z"
			fill="#555BE4"
		/>
	</svg>
);
export default UserSearch;
